module.exports = "/assets/nbo_LtPURE.png";